<template>
  <v-container fluid>
    <div class="text-h2">
      Fallo en la transacción
    </div>

    <v-subheader>
      Número de pedido <br />
      {{ this.puchase_data.orderNumber }}
    </v-subheader>

    <v-subheader>
      Fecha y hora <br />
      {{ this.puchase_data.orderDate }}
    </v-subheader>

    <v-subheader>
      Detalle <br />
      {{ this.puchase_data.failureReason }}
    </v-subheader>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import axios from "axios";
import { mapMutations, mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      tutorial: "terms",
      text: "Términos y Condiciones",
      uid: "",
      puchase_data: {
        orderNumber: this.$route.query.ordenNumber,
        orderDate: new Date(parseInt(this.$route.query.date)),
        failureReason: this.$route.query.description
      }
    };
  },
  computed: {
    ...mapState(["user"])
  },
  mounted() {
    // this.uid = this.user.uid;
    // this.purchase_data = this.purchaseData;
  },
  methods: {
    /*
    beforeRouteEnter (to, from, next) {

      console.log('Página no autorizada.')

      next(async vm => {
        const user = vm.user
        if (user.type === 'tutor' || user.type === 'parent') {
          vm.viewPage = true
          next()
        } else {
          console.log('Página no autorizada.')
          next({
            name: 'Home',
          })
        }
      })
    },
    */
  }
};
</script>
